<template>
  <v-container fluid>
    <v-progress-linear v-if="$vars.loading" indeterminate class="primary--text loader"></v-progress-linear>
    <v-toolbar dense flat>
      <v-tooltip bottom>
        <template v-slot:activator="{ on }">
          <v-btn icon @click="(showLieferung = true) && (neuLieferung = true) && (lieferung = neueLieferung)" v-on="on"
            ><v-icon>add</v-icon></v-btn
          >
        </template>
        <span>Erstellen</span>
      </v-tooltip>
      <v-tooltip bottom>
        <template v-slot:activator="{ on }">
          <v-btn icon disabled v-on="on"><v-icon>save_alt</v-icon></v-btn>
        </template>
        <span>Exportieren</span>
      </v-tooltip>
      <v-tooltip bottom>
        <template v-slot:activator="{ on }">
          <v-btn icon disabled v-on="on"><v-icon>delete</v-icon></v-btn>
        </template>
        <span>Löschen</span>
      </v-tooltip>
      <v-spacer></v-spacer>
      <v-toolbar-items>
        <v-text-field
          v-model="search"
          append-icon="search"
          label="Suchen"
          single-line
          solo
          flat
          hide-details
          clearable
          clear-icon="close"
        ></v-text-field>
      </v-toolbar-items>
    </v-toolbar>
    <v-divider></v-divider>
    <v-row class="ma-0">
      <v-col cols="12">
        <v-card outlined>
          <v-tabs v-model="tabs" center-active centered>
            <v-tab v-for="(bierlieferung, jahr) in bierlieferungen" :key="jahr">{{ jahr }}</v-tab>
          </v-tabs>
          <v-divider></v-divider>
          <v-tabs-items v-model="tabs">
            <v-tab-item v-for="(bierlieferung, jahr) in bierlieferungen" :key="jahr">
              <v-data-table
                height="calc(100vh - 240px)"
                dense
                :headers="headers"
                :items="bierlieferung"
                :search="search"
                fixed-header
                :items-per-page="-1"
                :hide-default-header="hideHeader"
                no-data-text="Keine Lieferungen vorhanden"
                hide-default-footer
              >
                <template v-slot:header="{ item }">
                  <tr class="hidden-sm-and-up">
                    <th>Datum</th>
                    <th>Lieferant</th>
                    <th>Rechnung</th>
                    <th>Betrag</th>
                    <th>Status</th>
                    <th></th>
                    <th></th>
                  </tr>
                </template>
                <template v-slot:item="{ item }">
                  <tr v-on:dblclick="(lieferung = item) && (showLieferung = true) && (neuLieferung = false)">
                    <td>{{ $filters.date(item.datum, "DD.MM.YYYY") }}</td>
                    <td>{{ item.lieferant }}</td>
                    <td>{{ item.rechnungsnummer }}</td>
                    <td class="text-right">{{ item.gesamt | money }}</td>
                    <td>{{ item.status }}</td>
                    <td width="20px" class="pl-0 pr-0" v-if="item.download" @click="downloadFile(item.id)">
                      <v-btn icon><v-icon>save_alt</v-icon></v-btn>
                    </td>
                    <td width="20px" class="pl-0 pr-0 red lighten-3" v-else>
                      <v-btn @click="showDialogUploadFile(item)" icon class="red--text"
                        ><v-icon>cloud_upload</v-icon></v-btn
                      >
                    </td>
                    <td width="20px" class="pl-0 pr-2">
                      <v-btn icon @click="(lieferung = item) && (showLieferung = true) && (neuLieferung = false)"
                        ><v-icon>edit</v-icon></v-btn
                      >
                    </td>
                  </tr>
                </template>
              </v-data-table>
            </v-tab-item>
          </v-tabs-items>
        </v-card>
      </v-col>
    </v-row>

    <v-dialog v-model="dialogUploadFile" width="500">
      <v-card>
        <v-card-title> Rechnung hochladen </v-card-title>

        <v-card-text>
          <v-file-input prepend-icon="attach_file" label="Datei auswählen" v-model="file"></v-file-input>
        </v-card-text>

        <v-divider></v-divider>

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn text @click="dialogUploadFile = false">Abbrechen</v-btn>
          <v-btn color="primary" @click="uploadFile"> Hochladen </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog v-model="showLieferung" fullscreen persistent scrollable>
      <v-card class="pa-0 ma-0">
        <v-progress-linear v-if="$vars.loading" indeterminate class="primary--text loader"></v-progress-linear>
        <v-card-title class="primary white--text">
          <div v-if="neuLieferung">Neue Lieferung erstellen</div>
          <div v-else>Lieferung {{ lieferung.rechnungsnummer }}</div>
          <v-spacer></v-spacer>
          <v-btn icon @click="showLieferung = false"><v-icon class="white--text">close</v-icon></v-btn>
        </v-card-title>

        <v-divider></v-divider>
        <v-card-text class="pa-0 ma-0">
          <v-toolbar dense flat>
            <v-spacer></v-spacer>
            <v-btn icon @click="updateDate(-1)"><v-icon>keyboard_arrow_left</v-icon></v-btn>
            <v-menu
              v-model="menu"
              :close-on-content-click="false"
              :nudge-left="65"
              :nudge-bottom="10"
              transition="scale-transition"
              offset-y
              min-width="290px"
            >
              <template v-slot:activator="{ on }">
                <v-btn text v-on="on"
                  ><span class="title">{{ $filters.date(lieferung.datum, "DD.MM.YYYY") }}</span></v-btn
                >
              </template>
              <v-date-picker
                no-title
                scrollable
                prev-icon="keyboard_arrow_left"
                next-icon="keyboard_arrow_right"
                v-model="lieferung.datum"
                @input="menu = false"
                locale="de-de"
              ></v-date-picker>
            </v-menu>
            <v-btn icon @click="updateDate(1)"><v-icon>keyboard_arrow_right</v-icon></v-btn>
            <v-spacer></v-spacer>
          </v-toolbar>
          <v-divider></v-divider>
          <v-row class="pa-0 ma-0">
            <v-col cols="4" md="2" offset-md="2">
              <v-card class="text-center py-2" outlined>
                <div class="subtitle-2">Summe</div>
                <div class="title">{{ summe | money }}</div>
              </v-card>
            </v-col>
            <v-col cols="4" md="2">
              <v-card class="text-center py-2" outlined>
                <div class="subtitle-2">Pfand</div>
                <div class="title">{{ summePfand | money }}</div>
              </v-card>
            </v-col>
            <v-col cols="4" md="2">
              <v-card class="text-center py-2" outlined>
                <div class="subtitle-2">MwSt.</div>
                <div class="title">{{ summeMwst | money }}</div>
              </v-card>
            </v-col>
            <v-col cols="4" md="2">
              <v-card class="text-center py-2" outlined>
                <div class="subtitle-2">Gesamt</div>
                <div class="title">{{ summeGesamt | money }}</div>
              </v-card>
            </v-col>
            <v-col cols="4" md="2" offset-md="2"
              ><v-autocomplete
                outlined
                :items="handler"
                hide-details
                dense
                v-model="lieferung.lieferant"
                label="Lieferant"
              ></v-autocomplete
            ></v-col>
            <v-col cols="4" md="2"
              ><v-text-field
                outlined
                hide-details
                dense
                v-model="lieferung.rechnungsnummer"
                label="Rechnungsnummer"
              ></v-text-field
            ></v-col>
            <v-col cols="4" md="2"
              ><v-text-field
                outlined
                hide-details
                dense
                v-model="lieferung.zahlungsdatum"
                label="Zahlungsdatum"
              ></v-text-field
            ></v-col>
            <v-col cols="4" md="2"
              ><v-text-field
                outlined
                hide-details
                dense
                v-model="lieferung.rabatt"
                type="number"
                label="Rabatt"
              ></v-text-field
            ></v-col>
          </v-row>
          <v-row class="pa-0 ma-0">
            <v-col cols="12" md="6">
              <v-card outlined>
                <v-card-title class="py-1">Getränke</v-card-title>
                <v-divider></v-divider>
                <v-row class="ma-0">
                  <v-col cols="7">
                    <v-autocomplete
                      hide-details
                      dense
                      outlined
                      label="Getränk"
                      :items="getranke"
                      v-model="getrank"
                    ></v-autocomplete>
                  </v-col>
                  <v-col cols="3">
                    <v-text-field
                      append-outer-icon="plus_one"
                      prepend-icon="exposure_neg_1"
                      @click:append-outer="anzahlGetrank++"
                      @click:prepend="anzahlGetrank > 0 ? anzahlGetrank-- : ''"
                      hide-details
                      dense
                      outlined
                      type="number"
                      min="0"
                      :value="anzahlGetrank"
                      v-model="anzahlGetrank"
                      label="Anzahl"
                    ></v-text-field>
                  </v-col>
                  <v-col cols="2" class="text-right">
                    <v-btn icon large dark class="primary" @click="addGetrank"><v-icon>playlist_add</v-icon></v-btn>
                  </v-col>
                </v-row>
                <v-simple-table dense fixed-header height="calc(100vh - 460px)">
                  <thead>
                    <tr>
                      <th>Bezeichnung</th>
                      <th>Anzahl</th>
                      <th>Netto</th>
                      <th>Summe</th>
                      <th width="20px"></th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr v-for="item in lieferung.positionen" :key="item.name">
                      <td>{{ item.bezeichnung }}</td>
                      <td>{{ item.anzahl }}</td>
                      <td>{{ item.netto | money }}</td>
                      <td>{{ item.summe | money }}</td>
                      <td>
                        <v-btn icon @click="delGetrank(item)"><v-icon>delete</v-icon></v-btn>
                      </td>
                    </tr>
                  </tbody>
                </v-simple-table>
              </v-card>
            </v-col>
            <v-col cols="12" md="6">
              <v-card outlined>
                <v-card-title class="py-1">Pfand zurück</v-card-title>
                <v-divider></v-divider>
                <v-row class="ma-0">
                  <v-col cols="7">
                    <v-autocomplete
                      hide-details
                      dense
                      outlined
                      label="Getränk"
                      :items="getranke"
                      v-model="pfand"
                    ></v-autocomplete>
                  </v-col>
                  <v-col cols="3">
                    <v-text-field
                      append-outer-icon="plus_one"
                      prepend-icon="exposure_neg_1"
                      @click:append-outer="anzahlPfand++"
                      @click:prepend="anzahlPfand > 0 ? anzahlPfand-- : ''"
                      hide-details
                      dense
                      outlined
                      type="number"
                      min="0"
                      :value="anzahlPfand"
                      v-model="anzahlPfand"
                      label="Anzahl"
                    ></v-text-field>
                  </v-col>
                  <v-col cols="2" class="text-right">
                    <v-btn icon large dark class="primary" @click="addPfand"><v-icon>playlist_add</v-icon></v-btn>
                  </v-col>
                </v-row>
                <v-simple-table dense fixed-header height="calc(100vh - 460px)">
                  <thead>
                    <tr>
                      <th>Bezeichnung</th>
                      <th>Anzahl</th>
                      <th>Pfand</th>
                      <th width="20px"></th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr v-for="item in lieferung.positionenPfand" :key="item.name">
                      <td>{{ item.bezeichnung }}</td>
                      <td>{{ item.anzahl }}</td>
                      <td>{{ item.pfand | money }}</td>
                      <td>
                        <v-btn icon @click="delPfand(item)"><v-icon>delete</v-icon></v-btn>
                      </td>
                    </tr>
                  </tbody>
                </v-simple-table>
              </v-card>
            </v-col>
          </v-row>
        </v-card-text>

        <v-divider></v-divider>

        <v-card-actions>
          <v-btn icon v-if="!neuLieferung" @click="showDeleteLieferung = true"><v-icon>delete</v-icon></v-btn>
          <v-spacer></v-spacer>
          <v-btn text @click="showLieferung = false">Abbrechen</v-btn>
          <v-btn v-if="neuLieferung" class="primary" text @click="saveLieferung()">Speichern</v-btn>
          <v-btn v-else class="primary" text @click="updateLieferung()">Update</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <dialogDelete
      :visible.sync="showDeleteLieferung"
      title="Lieferung löschen"
      message="Willst du diese Lieferung wirklich löschen?"
      abbrechen="Abbrechen"
      weiter="Löschen"
      @closeTrue="deleteLieferung()"
      @closeFalse="showDeleteLieferung = false"
    >
    </dialogDelete>
  </v-container>
</template>

<script>
  export default {
    props: ["on"],
    data() {
      return {
        selected: [],
        search: "",
        headers: [
          { text: "Datum", value: "datum" },
          { text: "Lieferant", value: "lieferant" },
          { text: "Rechnungsnummer", value: "rechnungsnummer" },
          { text: "Rechnungsbetrag", align: "right", value: "gesamt" },
          { text: "Status", value: "status" },
          { text: "", value: "download" },
          { text: "", sortable: false, value: "" },
        ],
        file: [],
        menu: false,
        getrank: "",
        pfand: "",
        anzahlGetrank: 0,
        anzahlPfand: 0,
        item: "",
        dialogUploadFile: false,
        showLieferung: false,
        tabs: 0,
        neuLieferung: false,
        lieferung: {},
        neueLieferung: {
          datum: new Date().toISOString().substr(0, 10),
          rechnungsnummer: "",
          positionen: [],
          positionenPfand: [],
          rabatt: 0,
          zahlungsdatum: "",
        },
        handler: ["Bier Schneider", "Oettinger", "Metro", "Getränke Vendel", "Rewe", "Vinos"],
        showDeleteLieferung: false,
      };
    },
    computed: {
      bierlieferungen() {
        if (this.$store.state.bierlieferungen.bierlieferungen.length === 0) {
          this.$store.dispatch("bierlieferungen/loadBierlieferungen");
        }
        let lieferungen = this.$store.state.bierlieferungen.bierlieferungen;
        lieferungen.forEach((lieferung) => {
          lieferung.jahr = lieferung.datum.split("-")[0];
        });
        const key = "jahr";
        const result = {};
        let tabs = 0;
        lieferungen.forEach((item) => {
          if (!result[item[key]]) {
            result[item[key]] = [];
            tabs++;
          }
          result[item[key]].push(item);
        });
        this.tabs = tabs - 1;
        return result;
      },
      getranke() {
        let getranke = [];
        if (this.$store.state.getranke.getranke.length === 0) {
          this.$store.dispatch("getranke/loadGetranke");
        }
        let alleGetranke = [];
        this.$store.state.getranke.getranke.forEach((item) => {
          if (item.switchBestellung) {
            alleGetranke.push(item);
          }
        });
        alleGetranke = alleGetranke.sort(function (a, b) {
          return a.nummer - b.nummer;
        });
        alleGetranke.forEach((item) => {
          getranke.push({
            id: item.id,
            text: item.bezeichnung,
            nummer: item.nummer,
            value: {
              item: item,
              id: item.id,
            },
          });
        });
        return getranke;
      },
      summe() {
        let summe = 0;
        if (this.lieferung.positionen) {
          this.lieferung.positionen.forEach((position) => {
            summe = summe + parseFloat(position.summe);
          });
        }
        if (this.lieferung.rabatt) {
          summe = summe - this.lieferung.rabatt;
        }
        return summe.toFixed(2);
      },
      summePfand() {
        let summe = 0;
        if (this.lieferung.positionen) {
          this.lieferung.positionen.forEach((position) => {
            summe = summe + parseFloat(position.pfand);
          });
        }
        if (this.lieferung.positionenPfand) {
          this.lieferung.positionenPfand.forEach((position) => {
            summe = summe - parseFloat(position.pfand);
          });
        }
        return summe;
      },
      summeMwst() {
        return (parseFloat(this.summe) + parseFloat(this.summePfand)) * 0.19;
      },
      summeGesamt() {
        return parseFloat(this.summe) + parseFloat(this.summePfand) + parseFloat(this.summeMwst);
      },
      hideHeader() {
        return this.$vuetify.breakpoint.name === "xs";
      },
    },
    methods: {
      showDialogUploadFile(item) {
        this.dialogUploadFile = true;
        this.item = item;
      },
      downloadFile(id) {
        this.$firebase
          .storage()
          .ref("bierrechnungen/" + id)
          .getDownloadURL()
          .then(function (url) {
            // `url` is the download URL for 'images/stars.jpg'
            window.open(url);
            // This can be downloaded directly:
          })
          .catch(function (error) {
            console.log(error);
          });
      },
      uploadFile() {
        let id = this.item.id;
        this.$firebase
          .storage()
          .ref("bierrechnungen/" + id)
          .put(this.file)
          .then(function (snapshot) {
            this.$firebase
              .firestore()
              .collection("vereine")
              .doc(this.$vars.verbindung)
              .collection("bierlieferungen")
              .doc(id)
              .update({ download: snapshot.ref.fullPath });
            (err) => {
              console.log(`Encountered error: ${err}`);
            };
          });
        this.file = [];
        this.dialogUploadFile = false;
      },
      delGetrank(item) {
        this.lieferung.positionen.splice(this.lieferung.positionen.indexOf(item), 1);
        this.$forceUpdate;
      },
      delPfand(item) {
        this.lieferung.positionenPfand.splice(this.lieferung.positionenPfand.indexOf(item), 1);
        this.$forceUpdate;
      },
      addGetrank() {
        if (!this.lieferung.positionen) {
          this.lieferung.positionen = [];
        }
        this.lieferung.positionen.push({
          id: this.getrank.id,
          bezeichnung: this.getrank.item.bezeichnung,
          anzahl: this.anzahlGetrank,
          netto: (this.getrank.item.preis / 1.19).toFixed(2),
          pfand: (this.getrank.item.pfand * this.anzahlGetrank).toFixed(2),
          summe: ((this.getrank.item.preis / 1.19) * this.anzahlGetrank).toFixed(2),
        });
        this.getrank = "";
        this.anzahlGetrank = 0;
        this.$forceUpdate;
      },
      addPfand() {
        if (!this.lieferung.positionenPfand) {
          this.lieferung.positionenPfand = [];
        }
        this.lieferung.positionenPfand.push({
          id: this.pfand.id,
          bezeichnung: this.pfand.item.bezeichnung,
          anzahl: this.anzahlPfand,
          pfand: this.pfand.item.pfand * this.anzahlPfand,
        });
        this.pfand = "";
        this.anzahlPfand = 0;
        this.$forceUpdate;
      },
      updateDate(value) {
        this.lieferung.datum = new Date(this.lieferung.datum);
        this.lieferung.datum = new Date(this.lieferung.datum.setDate(this.lieferung.datum.getDate() + value))
          .toISOString()
          .substr(0, 10);
      },
      updateLieferung() {
        this.lieferung.betrag = this.summe;
        this.lieferung.pfand = this.summePfand;
        this.lieferung.mwst = this.summeMwst;
        this.lieferung.gesamt = this.summeGesamt;
        this.$store.dispatch("bierlieferungen/updateBierlieferungData", this.lieferung);
        this.showLieferung = false;
        this.lieferung = [];
      },
      saveLieferung() {
        this.lieferung.betrag = this.summe;
        this.lieferung.pfand = this.summePfand;
        this.lieferung.mwst = this.summeMwst;
        this.lieferung.gesamt = this.summeGesamt;
        this.lieferung.status = "Erstellt";
        this.$store.dispatch("bierlieferungen/createBierlieferung", this.lieferung);
        this.showLieferung = false;
        this.lieferung = [];
      },
      deleteLieferung() {
        this.$store.dispatch("bierlieferungen/deleteBierlieferungData", this.lieferung.id);
        this.showLieferung = false;
        this.lieferung = [];
        this.showDeleteLieferung = false;
      },
    },
  };
</script>

<style scoped></style>



// WEBPACK FOOTER //
// bierwartBierlieferungen.vue?02972086